import { render, staticRenderFns } from "./TeamWorkDetails.vue?vue&type=template&id=fc7fc596"
import script from "./TeamWorkDetails.vue?vue&type=script&lang=js"
export * from "./TeamWorkDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports